<label class="zag-checkbox-container" [class.disabled]="disabled()">
  <input
    type="checkbox"
    class="zag-checkbox"
    [checked]="checked()"
    [disabled]="disabled()"
    [id]="id()"
    [name]="name()"
    [required]="required()"
    [class.focused]="focused()"
    (change)="onCheckboxChange($event)"
    (blur)="onBlur()"
    (focus)="onFocus()"
  />
  @if (label()) {
  <span class="zag-checkbox-label">{{ label() }}</span>
  }
</label>
